













import {Vue, Component, Prop, Emit, Model, Watch, Inject} from 'vue-property-decorator';

@Component({
  name: 'MyInput',
  mounted() {
  }
})
export default class MyInput extends Vue {
  @Prop() placeholder: string;
  @Prop() type: string;
  @Prop() readonly: boolean;

  @Model('change')
  propVal: string

  get selfVal(): string {
    return this.propVal
  };
  set selfVal(newValue) {
    this.emitChange(newValue);
  }

  handleFocus() {
  }
  handleBlur() {
    this.emitBlur();
  }
  handleClick() {
    this.emitClick();
  }

  @Emit('change')
  emitChange(newValue: any): void {
  }

  @Emit('blur')
  emitBlur(): void {
    if (this.$parent.isNeedCheck) {
      this.$parent.onChangeFormResult(this.selfVal);
    }
  }

  @Emit('click')
  emitClick(): void {
  }
}
